export default __webpack_public_path__ + "static/media/echoes.9cfa8a46.png";